<script setup lang="ts">
import { UiAside, UiButton, UiText, UiIcon, UiFormBuilder } from '@shopexperts/shared';
import { z } from 'zod';
import type { BuilderRowConfig } from '@shopexperts/shared';

const props = defineProps<{
    schema?: z.ZodType<Record<string, unknown>>;
    rows?: BuilderRowConfig[];
    title: string;
    description: string;
    submitLabel?: string;
}>();

const asideOpen = defineModel<boolean>('open');
const emit = defineEmits<{
    (e: 'submit', values: Record<string, unknown>): void;
}>();

const onCancel = () => {
    asideOpen.value = false;
};

const onSubmit = (values: Record<string, unknown>) => {
    console.log(values);
    emit('submit', values);
};
</script>
<template>
    <UiAside v-model="asideOpen" position="right" :close-on-overlay-click="false">
        <div class="px-4 py-6 md:p-8 flex flex-col gap-4 max-h-full overflow-y-auto">
            <div class="flex items-center justify-between">
                <UiText as="h3" :text="props.title" />
                <UiButton variant="ghost" shape="square" @click="onCancel">
                    <template #before_label>
                        <UiIcon name="close" class="w-6 h-6" />
                    </template>
                </UiButton>
            </div>
            <UiText as="p" class="text-gray-600 mb-4" :text="props.description" />
            <slot name="form">
                <UiFormBuilder v-if="schema && rows" :schema="schema" :rows="rows" scroll-to-first-error @submit="onSubmit">
                    <template #actions>
                        <UiButton v-if="props.submitLabel" type="submit" variant="primary" :label="props.submitLabel" />
                    </template>
                </UiFormBuilder>
            </slot>
        </div>
    </UiAside>
</template>